module.exports = __webpack_public_path__ + "img/box6-img-1.b8e134b8.png";